<template>
  <b-card>
      <!-- Form -->
      <b-form
        class="p-2"
      >
        <b-row>
          <b-col
            xl="6"
          >
           <b-form-group
              label="Judul"
              label-for="judul"
            >
              <b-form-textarea
                id="judul"
                v-model="rowData.judul"
                rows="3"
                :disabled="true"
              />
            </b-form-group>

            <b-form-group
              label="Tanggal"
              label-for="tanggal"
            >
              <b-form-datepicker v-model="rowData.tanggal" locale="id"></b-form-datepicker>
            </b-form-group>

             <b-form-group
              label="Waktu Ujian"
              label-for="waktu_ujian_id"
            >
              <v-select
                id="waktu_ujian_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="waktuUjianOption.options"
                v-model="rowData.waktu_ujian_id"
                placeholder="Pilih Waktu Ujian"
              />
            </b-form-group>

            <b-form-group
              label="Ruangan"
              label-for="ruangan_id"
            >
              <v-select
                id="ruangan_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="ruanganOption.options"
                v-model="rowData.ruangan_id"
                placeholder="Pilih Ruangan"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
          >
            Simpan
          </b-button>
        </div>

      </b-form>
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div v-if="this.error_check.length == 0">
            <div class="d-flex justify-content-center mt-2">
              <b-spinner
              :variant="'dark'"
              ></b-spinner>
            </div>
            <div class="d-flex justify-content-center mt-2">
            Loading....
            </div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-center mt-2">
              <h4 style="color:red;">Gagal Memuat Data</h4>
            </div>
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton, BFormTextarea, BFormDatepicker, BModal, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { ref } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { avatarText } from '@core/utils/filter'
import useList from '@/connection-api/jenis-dokumen/list'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import {
  getRuangan,
  getDetailJadwalSidang,
  getWaktuUjian,
  updateJadwalSidang,
} from '@/connection-api/master'
require('moment/locale/id');

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormDatepicker,
    vSelect,
    BModal,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      error_check: [],
      success_check: [],
      showModal: 0,
      rowData: {},
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu Ujian --' },
        ],
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
    }
  },
  mounted() {
    this.$bvModal.show('modal-center-loading')
    getDetailJadwalSidang(this.$route.params.uuid)
      .then(response => {
        this.rowData = response.data.data;
        this.success_check.push('success')
        this.completeCheck()
      })
    .catch(error => {
      this.error_check.push(error)
    });
    this.getRuanganF()
    this.getWaktuF()
  },
  methods: {
    completeCheck()
    {
      if(this.success_check.length == 2 && this.error_check.length == 0)
      {
        this.showModal = 0
      }
    },
    getRuanganF() {
      getRuangan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.ruanganOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        this.success_check.push('success')
        this.completeCheck()
      }
      })
      .catch(error => {
        console.log(error)
        this.getRuanganF()
      });
    },
    getWaktuF() {
      getWaktuUjian()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.waktuUjianOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        this.success_check.push('success')
        this.completeCheck()
      }
      })
      .catch(error => {
        this.getWaktuF()
      });
    },
    updateData() {
      var params = {
        id: this.$route.params.uuid,
        params: this.rowData,
      }
      updateJadwalSidang(params)
      .then(response => {
      if (response.data.success == true) {
        this.makeToast('success', 'Data berhasil disimpan')
        setTimeout(() => {
          this.$router.push({name: 'jadwal-sidang'})
        }, 2000);
        this.success_check.push('success')
        this.completeCheck()
      } else {
        this.makeToast('danger', response.data.message)
      }
      })
      .catch(error => {
        console.log(error)
      });
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      moment.locale('id');
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Jadwal Sidang',
        variant,
        solid: true,
        autoHideDelay: 4000,
      })
    },
  },
}
</script>

<style>

</style>
